<template>
  <div class="home">
    <v-container>
      <v-row>
        <v-col cols="12" md="3">
          <v-btn color="primary" @click="resetEnvironment">reset test environment</v-btn>
        </v-col>
        <v-col cols="12" md="3">
          <v-btn color="primary" @click="removeSurveys">remove surveys</v-btn>
        </v-col>
        <v-col cols="12" md="3">
          <v-btn color="primary" @click="invalidateSession">invalidate session</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { questionService } from "@/services/question";
import { sessionService } from "@/services/login";

const clientId = "client-example-23";
const surveyId = "survey-01";

export default {
  name: "Home",
  methods: {
    resetEnvironment() {
      questionService.storeSurvey(clientId, surveyId, this.survey);
    },
    removeSurveys() {
      questionService.deleteAllSurveys(clientId, surveyId);
    },
    invalidateSession() {
      sessionService.invalidateSession();
      history.go(0);
    }
  },
  data() {
    return {
      survey: [
        {
          "id": "s1",
          "type": "select",
          "question": "Please select a vehicle",
          "answer": null,
          "options": [
            {
              "key": "car",
              "caption": "Car",
              "forwardTo": "car-question-01"
            },
            {
              "key": "bicycle",
              "caption": "Bicycle",
              "forwardTo": "bicycle-01"
            },
            {
              "key": "boat",
              "caption": "Boat",
              "forwardTo": "boat-01"
            },
            {
              "key": "new-questions",
              "caption": "New questions",
              "forwardTo": "new-questions-01"
            },
            {
              "key": "new-photo-question",
              "caption": "New photo question",
              "forwardTo": "new-photo-01"
            }
          ]
        },
        {
          "id": "car-question-01",
          "type": "radio",
          "question": "How many wheels?",
          "answer": null,
          "options": [
            {
              "key": "0wheels",
              "caption": "2",
              "forwardTo": null
            },
            {
              "key": "1wheel",
              "caption": "3",
              "forwardTo": null
            },
            {
              "key": "2wheels",
              "caption": "4",
              "forwardTo": null
            },
            {
              "key": "3wheels",
              "caption": "6",
              "forwardTo": null
            }
          ]
        },
        {
          "id": "car-question-02",
          "type": "radio",
          "question": "How many doors?",
          "answer": null,
          "options": [
            {
              "key": "2doors",
              "caption": "2",
              "forwardTo": null
            },
            {
              "key": "3doors",
              "caption": "3",
              "forwardTo": null
            },
            {
              "key": "5doors",
              "caption": "5",
              "forwardTo": null
            }
          ]
        },
        {
          "id": "car-end-survey",
          "type": "end-survey",
          "question": null
        },
        {
          "id": "bicycle-01",
          "type": "text",
          "question": "What is the color?",
          "answer": null
        },
        {
          "id": "bicycle-end-survey",
          "type": "end-survey",
          "question": null
        },
        {
          "id": "boat-01",
          "type": "radio",
          "question": "What kind of boat?",
          "answer": null,
          "options": [
            {
              "key": "canoe",
              "caption": "Canoe",
              "forwardTo": null
            },
            {
              "key": "motor",
              "caption": "Motorboat",
              "forwardTo": null
            },
            {
              "key": "sail",
              "caption": "Sail boat",
              "forwardTo": null
            }
          ]
        },
        {
          "id": "end-survey",
          "type": "end-survey",
          "question": null
        },
        {
          "id": "new-questions-01",
          "type": "number",
          "question": "Give in pin (only numbers): ",
          answer: null
        },
        {
          "id": "new-questions-02",
          "type": "email",
          "question": "Give in email: ",
          answer: null
        },
        {
          "id": "new-questions-03",
          "type": "telephone",
          "question": "What's your phone number? ",
          answer: null
        },
        {
          "id": "end-survey-newq",
          "type": "end-survey",
          "question": null
        },
        {
          "id": "new-photo-01",
          "type": "photo",
          "question": "Make photo of kitchen"
        },
        {
          "id": "end-survey-new-photo",
          "type": "end-survey",
          "question": null
        }
      ]
    };
  }
};
</script>
